import { useEffect } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';

/**
 * Redirects /?category=design → /categories/design (client-side 301-equivalent).
 * Renders nothing while redirecting. If no `category` param is set, returns null
 * so the parent can render the normal Index page.
 */
export function CategoryQueryRedirect({ children }: { children: React.ReactNode }) {
  const [params] = useSearchParams();
  const cat = params.get('category');

  if (cat) {
    // Strip the param so we don't loop
    return <Navigate to={`/categories/${cat.toLowerCase()}`} replace />;
  }

  return <>{children}</>;
}

/**
 * Generic component that does a client-side replace navigation to the given path.
 * Use as `element={<RedirectTo to="/marketplace" />}`.
 */
export function RedirectTo({ to }: { to: string }) {
  // useEffect not needed — Navigate replaces immediately on render.
  return <Navigate to={to} replace />;
}
